import { type Ref } from 'react';

import { type Optional } from 'utility-types';

import { Button, type ButtonProps } from '@craft/ui/components/buttons';

import { Auth0Config, Auth0QueryParameter } from '@/src/integrations/auth0';

export interface SignInButtonProps extends Omit<
  Optional<ButtonProps<'a'>, 'children'>,
  'component' | 'href' | 'onClick' | 'target'
> {
  readonly ref?: Ref<HTMLAnchorElement>;
  readonly returnTo: null | string;
}

export const SignInButton = ({ ref, returnTo, ...props }: SignInButtonProps) => (
  <Button
    color='primary'
    variant='contained'
    {...props}
    component='a'
    href={
      returnTo
        ? Auth0Config.fromEnvironment().loginPath({ [Auth0QueryParameter.ReturnTo]: returnTo })
        : Auth0Config.fromEnvironment().loginPath({})
    }
    ref={ref}
  >
    {props.children ?? 'Sign In'}
  </Button>
);
